import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { deepMerge } from 'utils/collection-manipulation/deep-merge';
import { FavoritePersonalization } from 'services/favorite-personalization';
import { setPersonalizedGenericSettings } from 'store/actions/app-data';
import { getIsLoggedIn } from 'store/selectors/user-data';

export const FetchGenericSettings = () => {
  const isLoggedIn = useSelector(getIsLoggedIn);

  const dispatch = useDispatch();
  const { prepareFavoritesInitialData } = FavoritePersonalization();

  useEffect(() => {
    if (isLoggedIn) {
      prepareFavoritesInitialData(preparedData => {
        const newData = deepMerge(
          { accountSettings: {} },
          preparedData.personalizationGenericSettings || {},
          { shouldMergeInFirst: false, applyEmptyArraysAndObjects: true }
        );

        dispatch(setPersonalizedGenericSettings(newData));
      }, true);
    }
  }, [isLoggedIn]);

  useEffect(() => {
    if (!isLoggedIn) {
      dispatch(setPersonalizedGenericSettings({}));
    }
  }, [isLoggedIn]);

  return null;
};
